import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { DeleteButton } from '@/components/form/baseInputs/Button/DeleteButton';
import { SidePanel } from '@/components/modals/SidePanel';
import { COLORS } from '@/styles/tokens/colors';

import { useSelectedEditableNode } from '../hooks/useSelectedEditableNode';

export function SettingsPanel() {
  const { selected, actions, query } = useSelectedEditableNode();
  const [initialNodeState, setInitialNodeState] = useState<string | null>(null);

  // Capture initial state when a node is selected
  useEffect(() => {
    if (selected?.id) {
      const nodeState = query.node(selected.id).get();
      setInitialNodeState(JSON.stringify(nodeState.data.props));
    }
  }, [selected?.id, query]);

  const handleClose = () => {
    actions.selectNode(undefined);
    setInitialNodeState(null);
  };

  const handleCancelChanges = () => {
    if (selected?.id && initialNodeState) {
      // Restore the initial node state
      const parsedState = JSON.parse(initialNodeState);
      actions.setProp(selected.id, (props: Record<string, unknown>) => {
        // Clear all existing properties first to remove any properties
        // added during editing that weren't in the original state
        for (const key of Object.keys(props)) {
          delete props[key];
        }
        Object.assign(props, parsedState);
      });
    }
    handleClose();
  };

  const handleDelete = () => {
    if (selected?.id) {
      actions.delete(selected.id);
      setInitialNodeState(null);
    }
  };

  const SettingsComponent = selected?.related?.settings;

  if (!SettingsComponent) {
    return null;
  }

  return (
    <SidePanel.Panel
      variant="outlined"
      style={{
        width: '332px',
        flexShrink: 0,
        borderRadius: 0,
        borderTop: 'none',
        borderBottom: 'none',
      }}
    >
      <SidePanel.Header title="Edit Component" onClose={handleClose} />
      <SidePanel.Content>
        <SidePanel.Section>
          <SettingsComponent />
        </SidePanel.Section>
      </SidePanel.Content>
      <SidePanel.Footer borderTop={`1px solid ${COLORS.GRAY[200]}`}>
        <Stack direction="row" width="100%" justifyContent="space-between">
          <DeleteButton
            size="sm"
            variant="destructive-secondary"
            onConfirmDelete={handleDelete}
          />
          <Button variant="secondary" size="sm" onClick={handleCancelChanges}>
            Cancel changes
          </Button>
        </Stack>
      </SidePanel.Footer>
    </SidePanel.Panel>
  );
}
